import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Clientes.css";
import { API_URL } from "../config";

export default function Clientes() {
  const navigate = useNavigate();

  const [clientes, setClientes] = useState([]);
  const [asesores, setAsesores] = useState([]);
  const [grupos, setGrupos] = useState([]);

  // FILTROS
  const [filtroId, setFiltroId] = useState("");
  const [filtroNombre, setFiltroNombre] = useState("");
  const [filtroEstatus, setFiltroEstatus] = useState("");
  const [filtroAsesor, setFiltroAsesor] = useState("");
  const [filtroGrupo, setFiltroGrupo] = useState("");

  // PAGINACIÓN
  const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [totalPaginas, setTotalPaginas] = useState(1);

  const irACrearCliente = () => navigate("crear");

  // =============================
  // CARGAR CLIENTES (PAGINADO)
  // =============================
  const cargarClientes = async () => {
    try {
      const token = localStorage.getItem("token");

      const params = new URLSearchParams({
        page,
        limit,
        id: filtroId,
        nombre: filtroNombre,
        estatus: filtroEstatus,
        asesor: filtroAsesor,
        grupo: filtroGrupo
      });

      const res = await fetch(`${API_URL}/clientes?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Error al cargar clientes");
        return;
      }

      setClientes(data.data);
      setTotalPaginas(Math.ceil(data.total / limit));

    } catch (error) {
      console.error(error);
      alert("Error al conectar con el servidor");
    }
  };

  // =============================
  // CARGAR CATÁLOGOS
  // =============================
  const cargarCatalogos = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const [resAsesores, resGrupos] = await Promise.all([
        fetch(`${API_URL}/asesores`, { headers }),
        fetch(`${API_URL}/grupos`, { headers })
      ]);

      setAsesores(await resAsesores.json());
      setGrupos(await resGrupos.json());

    } catch (err) {
      console.error(err);
      alert("Error al cargar catálogos");
    }
  };

  // =============================
  // USE EFFECT
  // =============================
  useEffect(() => {
    cargarCatalogos();
  }, []);

  useEffect(() => {
    cargarClientes();
  }, [page, filtroId, filtroNombre, filtroEstatus, filtroAsesor, filtroGrupo]);

  return (
    <div className="clientes-container">

      {/* ENCABEZADO */}
      <div className="clientes-top-bar">
        <h1 className="clientes-title">Clientes</h1>
        <button className="btn-crear" onClick={irACrearCliente}>Crear cliente</button>
      </div>

      {/* FILTROS */}
      <div className="clientes-filtros">

        <div className="filtro-item">
          <label>ID</label>
          <input
            type="text"
            placeholder="Ej. 1"
            value={filtroId}
            onChange={(e) => { setPage(1); setFiltroId(e.target.value); }}
          />
        </div>

        <div className="filtro-item">
          <label>Nombre del cliente</label>
          <input
            type="text"
            placeholder="Ej. Juan Pérez"
            value={filtroNombre}
            onChange={(e) => { setPage(1); setFiltroNombre(e.target.value); }}
          />
        </div>

        <div className="filtro-item">
          <label>Estatus</label>
          <select value={filtroEstatus} onChange={(e) => { setPage(1); setFiltroEstatus(e.target.value); }}>
            <option value="">Todos</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
        </div>

        <div className="filtro-item">
          <label>Asesor</label>
          <select value={filtroAsesor} onChange={(e) => { setPage(1); setFiltroAsesor(e.target.value); }}>
            <option value="">Todos</option>
            {asesores.map((a) => (
              <option key={a.id} value={a.id}>{a.alias}</option>
            ))}
          </select>
        </div>

        <div className="filtro-item">
          <label>Grupo</label>
          <select value={filtroGrupo} onChange={(e) => { setPage(1); setFiltroGrupo(e.target.value); }}>
            <option value="">Todos</option>
            {grupos.map((g) => (
              <option key={g.id} value={g.id}>{g.nombre}</option>
            ))}
          </select>
        </div>

      </div>

      {/* TABLA */}
      <table className="clientes-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Semáforo</th>
            <th>Tipo</th>
            <th>Papelería</th>
            <th>Estatus</th>
            <th>Acción</th>
          </tr>
        </thead>

        <tbody>
          {clientes.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                No hay clientes que coincidan con los filtros
              </td>
            </tr>
          ) : (
            clientes.map((c) => {
              const nombreCompleto = [
                c.Nombre,
                c.Apellido_Paterno,
                c.Apellido_Materno
              ].filter(Boolean).join(" ");

              return (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{nombreCompleto}</td>

                  <td><span className={`chip ${c.semaforo}`}>{c.semaforo}</span></td>

                  <td><span className={`chip ${c.tipo_cliente}`}>{c.tipo_cliente}</span></td>

                  <td>
                    <span className={`chip ${
                      c.expediente_completo === 7
                        ? "completo"
                        : c.expediente_completo >= 5
                        ? "casi"
                        : "incompleto"
                    }`}>
                      {c.expediente_completo}/7
                    </span>
                  </td>

                  <td>
                    <span className={`chip ${c.activo === 1 ? "activo" : "inactivo"}`}>
                      {c.activo === 1 ? "Activo" : "Inactivo"}
                    </span>
                  </td>

                  <td>
                    <button className="btn-ver" onClick={() => navigate(`/clientes/${c.id}`)}>
                      Ver
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {/* PAGINACIÓN */}
      <div className="paginacion">
        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
          Anterior
        </button>

        <span>Página {page} de {totalPaginas}</span>

        <button disabled={page === totalPaginas} onClick={() => setPage(page + 1)}>
          Siguiente
        </button>
      </div>

    </div>
  );
}
